// Workplace Communication Research (2026-02) — the ONLY two tracking
// calls for this feature: `research_started`/`research_submitted`.
// Both go to the single canonical ingestion route
// `POST /api/research/events` (see `routers/research_routes.py` +
// `research_tracking_dispatch.py`). Never PostHog directly from the
// browser — the backend is the sole gate that decides, from the
// `analytics_consent` value reported here, whether to forward to
// PostHog at all. Best-effort only: a network failure here must never
// block or alter the research UX.
import { getAnalyticsConsentState } from "@/hooks/useConsent";

const API_URL = process.env.REACT_APP_BACKEND_URL;

const postResearchEvent = (eventType, { language, audience, formId, sessionNonce }) => {
  try {
    fetch(`${API_URL}/api/research/events`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        event_type: eventType,
        research_id: "workplace_communication",
        language,
        audience,
        form_id: formId,
        session_nonce: sessionNonce,
        analytics_consent: getAnalyticsConsentState(),
      }),
      keepalive: true,
    }).catch(() => {
      /* best-effort only */
    });
  } catch {
    /* best-effort only */
  }
};

export const trackResearchStarted = (args) => postResearchEvent("research_started", args);
export const trackResearchSubmitted = (args) => postResearchEvent("research_submitted", args);
